import { z } from "zod"

export const DEFAULT_PAGE_SIZE = 20
export const DEFAULT_PAGE = 0
export const DEFAULT_PAGE_SIZE_BOX_PROGRAM = 100

export type Page<T> = {
  content: readonly T[]
  page: number
  totalPages: number
  totalSize: number
}

export const PaginatedDtoSchema = <T extends z.ZodTypeAny>(itemSchema: T) =>
  z.object({
    content: z.array(itemSchema),
    contentSize: z.number(),
    offset: z.number(),
    page: z.number(),
    pageSize: z.number(),
    totalElements: z.number(),
    totalPages: z.number(),
    last: z.boolean(),
  })

export type Paginated<T> = z.infer<ReturnType<typeof PaginatedDtoSchema<z.ZodType<T>>>>

export type SortObject = {
  direction: string
  nullHandling: string
  ascending: boolean
  property: string
  ignoreCase: boolean
}

// Deprecated - Object Spring de base - Lié à PaginatedWrapper
export type PageableObject = {
  offset: number
  sort: SortObject
  paged: boolean
  pageNumber: number
  pageSize: number
  unpaged: boolean
}

// Deprecated - Object Spring de base
// Object DTO renvoyer par le backend
export type PaginatedWrapper<T> = {
  content: readonly T[]
  pageable: PageableObject
  totalElements: number
  totalPages: number
  last: boolean
  size: number
  number: number
  first: boolean
  empty: boolean
  sort: SortObject
}

// Deprecated - lié à l'objet Spring
export function wrapperToPage<T>(data: PaginatedWrapper<T>): Page<T> {
  return {
    page: data.number,
    content: data.content,
    totalPages: data.totalPages,
    totalSize: data.totalElements,
  }
}

// Bonne fonction à utiliser
export function toPage<T>(data: Paginated<T>): Page<T> {
  return {
    page: data.page,
    content: data.content,
    totalPages: data.totalPages,
    totalSize: data.totalElements,
  }
}

export function toFakePage<T>(data: T[]): Page<T> {
  return {
    page: 1,
    content: data,
    totalPages: 1,
    totalSize: data.length,
  }
}

export type PaginatedCursor<T> = {
  data: T[]
  hasMore: boolean
  nextPage?: string
}
